import React from "react";
import Avatar from "@mui/material/Avatar";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  TicketItem,
  TicketInfo,
  TicketText,
  ActionText,
  TicketDate,
  ViewAll,
  StatusAndDateWrapper,
  StatusDot,
  StatusText,
} from "./style";
import { FormattedMessage } from "react-intl";
import { FormatDateTime } from "../../../../../../utils/helpers/FormatDateTime";
import { translateStatusString } from "../../../../../../utils/helpers/translateStatusString";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../../../../../redux/features/language/languageSlice";

const getStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case "open":
      return "status-info";
    case "closed":
      return "status-closed";
    case "inprogress":
      return "status-progress";
    case "completed":
      return "status-completed";
    default:
      return "status-default";
  }
};

const SingleTicket = ({ avatar, name, status, date, action }) => {
  const statusClass = getStatusColor(status);
  const currentLanguage = useSelector(selectLanguage);

  return (
    <TicketItem>
      <TicketInfo>
        <TicketText>
          <div>{name}</div>
          <ActionText>{action}</ActionText>
        </TicketText>
      </TicketInfo>
      <StatusAndDateWrapper>
        <div style={{ display: "flex", alignItems: "center" }}>
          <StatusDot className={statusClass} />
          <StatusText>
            {translateStatusString(status, currentLanguage)}
          </StatusText>
        </div>
        <TicketDate>
          <FormatDateTime value={date} />
        </TicketDate>
      </StatusAndDateWrapper>
    </TicketItem>
  );
};

export const ViewAllTickets = ({ onClick }) => (
  <ViewAll onClick={onClick}>
    <FormattedMessage id="button.viewAll" />{" "}
    <ArrowForwardIosIcon fontSize="small" className="icon" />
  </ViewAll>
);

export default SingleTicket;
